import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MaterialDialogTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4, 3, 1),
  },
  title: {
    fontWeight: theme.typography.fontWeightLight,
  },
});

const DialogTitle = ({
  className,
  classes,
  componentResource,
}) => {
  return (
    <MaterialDialogTitle
      className={classNames(classes.root, className)}
      disableTypography
    >
      <Typography
        className={classes.title}
        color="primary"
        component="span"
        variant="h1"
      >
        {componentResource.attr('name')}
      </Typography>
    </MaterialDialogTitle>
  );
};

DialogTitle.defaultProps = {
  className: '',
};

DialogTitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  componentResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(DialogTitle);
